
import { Copy, ArrowRightLeft } from 'lucide-react';

const CopyMoveModal = ({ onCopy, onMove, onCancel }) => (<div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fade-in-up">
    <div className="bg-white rounded-2xl shadow-2xl p-6 text-center max-w-[90vw] sm:max-w-md w-full">
        <h2 className="text-xl font-bold mb-4 text-gray-800">Action</h2>
        <p className="text-gray-600 mb-6">Do you want to copy or move the activity?</p>

        <div className="flex flex-col sm:flex-row justify-center gap-3">
            <button
                onClick={onCopy}
                className="px-4 py-2 bg-white border border-gray-300 text-gray-700 font-semibold rounded-lg shadow hover:bg-gray-100 transition-all flex items-center justify-center"
            >
                <Copy size={16} className="mr-2" />
                Copy
            </button>

            <button
                onClick={onMove}
                className="px-4 py-2 bg-[#166273] text-white font-semibold rounded-lg shadow-md hover:bg-[#166273]/90 transition-all flex items-center justify-center"
            >
                <ArrowRightLeft size={16} className="mr-2" />
                Move
            </button>

            <button
                onClick={onCancel}
                className="px-4 py-2 text-gray-600 font-semibold hover:text-gray-800 transition"
            >
                Cancel
            </button>
        </div>
    </div>
</div>
);

export default CopyMoveModal;